module.exports = __webpack_public_path__ + "img/cvv.c973a7b0.svg";